import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const HU: DeepPartial<Payments> = {
    useReceiverEndpoint: true,
    redoReplyEngine: 'paymentService',
    maxDaysInFuture: 365,
    putCancelledByUserToDone: true,
    ignoreTrailingZerosInAccountNumber: true,
    preferBbanDisplay: true,
    disableTransferDateForFxIntrabankPaymentReceiver: true,
    disableTransferDateForFX: true,
    instantPayments: {
        shouldShowSigningLogo: true,
        signingLogoUpperLimit: 20_000_000,
    },
    trustedContactsAvailable: true,
};
